<template>
  <div>
    <!-- <vx-card>
        <vs-row
          vs-align="flex-start"
          vs-type="flex"
          vs-justify="center"
          vs-w="12"
        >
          <h3>Count of Activated Codes</h3>
          <vs-col vs-w="12">
            <line-chart
              :chart-data="numbers"
              :chart-labels="lables"
              ref="line"
            ></line-chart>
          </vs-col>
        </vs-row>
      </vx-card>
  
      <vx-card>
        <vs-row
          vs-align="flex-start"
          vs-type="flex"
          vs-justify="center"
          vs-w="12"
        >
          <h3>Count of Activated Codes</h3>
          <vs-col vs-w="12">
            <line-chart
              :chart-data="numbers2"
              :chart-labels="lables2"
              ref="line2"
            ></line-chart>
          </vs-col>
        </vs-row>
      </vx-card> -->

    <vx-card class="mb-5">
      <h1 style="text-align: center">مراكز التوزيع</h1>
      <vs-table
        max-items="100"
        noDataText="لا يوجد بيانات"
        :data="data.distributors"
      >
        <template slot="header"> </template>

        <template slot="thead">
          <vs-th sort-key="name">Name</vs-th>
          <vs-th sort-key="name">Number of sells</vs-th>
          <vs-th sort-key="name">Number of active codes</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              {{ data[indextr].name }}
            </vs-td>
            <vs-td>
              {{ data[indextr].numberOfSell }}
            </vs-td>
            <vs-td>
              {{ data[indextr].numberOfCodes }}
            </vs-td>
          </vs-tr>
          <vs-tr key="12310">
            <vs-td>
              المجموع الكلي:
            </vs-td>
            <vs-td>
              {{ totalSells }}
            </vs-td>
            <vs-td></vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <hr />
      <h1>Total Users: {{ totalUsers }}</h1>

      <hr />
      <vs-input
        placeholder="Code"
        vs-placeholder="Code"
        v-model="code"
        class="mt-3 w-full"
      />
      <vs-button
        class="mt-3 w-full"
        color="success"
        type="border"
        @click="checkCode"
        >checkCode</vs-button
      >
      <div v-if="coupon != null">
        <p class="text-wrap">
          {{ coupon.status ? "الكود غير مفعل" : "الكود مفعل" }}
        </p>
        <div v-if="user">
          <p class="text-wrap" v-if="user">Username: {{ user.name }}</p>
          <p class="text-wrap" v-if="user">Email: {{ user.email }}</p>
        </div>
        <div v-if="course">
          <p class="text-wrap" v-if="user">Course Title: {{ course.title }}</p>
        </div>
      </div>

      <hr />

      <h1 style="text-align: center">تفاصيل الدورات</h1>
      <vs-table
        max-items="100"
        noDataText="لا يوجد بيانات"
        :data="data.coursesByDistributors"
      >
        <template slot="header"> </template>

        <template slot="thead">
          <vs-th sort-key="name">Course Name</vs-th>
          <vs-th sort-key="name">Number of Course Activation</vs-th>
          <!-- <vs-th sort-key="name">Number of Free Course Activation</vs-th> -->
          <!-- <vs-th sort-key="name">Total</vs-th> -->
        </template>
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              {{ data[indextr].name }}
            </vs-td>
            <vs-td>
              {{ data[indextr].numberOfSell }}
            </vs-td>
            <!-- <vs-td>
              {{ data[indextr].numberOfFreeActivation }}
            </vs-td>
            <vs-td>
              {{
                data[indextr].numberOfActivation +
                  data[indextr].numberOfFreeActivation
              }}
            </vs-td> -->
          </vs-tr>
        </template>
      </vs-table>

      <!-- 
      <h1 style="text-align: center">تفاصيل المستخدمين</h1>
      <vs-table
        max-items="100"
        noDataText="لا يوجد بيانات"
        :data="data.usersByUniversity"
      >
        <template slot="header"> </template>

        <template slot="thead">
          <vs-th sort-key="name">University Name</vs-th>
          <vs-th sort-key="name">Number of users</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              {{ data[indextr].name }}
            </vs-td>
            <vs-td>
              {{ data[indextr].total }}
            </vs-td>
          </vs-tr>
          <vs-tr key="12312">
            <vs-td>
              المجموع الكلي:
            </vs-td>
            <vs-td>
              {{ totalUsers }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table> -->
    </vx-card>

    <vx-card> </vx-card>
  </div>
</template>

<script>
// import addEditForm from "./form";
import { BTable } from "bootstrap-vue";
import StatisticCardVertical from "./stats/StatisticCardVertical.vue";
import { BRow, BCol } from "bootstrap-vue";
import LineChart from "@/components/LineChart";

export default {
  components: {
    BTable,
    StatisticCardVertical,
    BRow,
    BCol,
    LineChart
  },
  data: () => ({
    deleteItemId: -1,
    deletePrompt: false,
    activePrompt: false,
    data: [],
    website_traffic: {
      dates: [],
      visitors: []
    },
    website_traffic2: {
      dates: [],
      visitors: []
    },

    totalUsers: 0,
    totalSells: 0,
    code: null,
    coupon: null,
    user: null,
    course: null
  }),
  mounted() {
    this.getData();
  },

  methods: {
    async checkCode() {
      await this.$vs.loading();
      try {
        await axios.post("/check-code/", { code: this.code }).then(response => {
          this.coupon = response.data.coupon;
          this.user = response.data.user;
          this.course = response.data.course;
        });
      } catch (e) {
        this.coupon = null;
        this.user = null;
        this.course = null;
      }
      await this.$vs.loading.close();
    },
    async getData() {
      await this.$vs.loading();
      await axios.get("/get-statistics").then(response => {
        this.data = response.data;
        // this.data.usersByUniversity.forEach(element => {
        //   this.totalUsers += parseInt(element.total);
        // });
        this.totalUsers = this.data.numberOfUsers;
        this.data.distributors.forEach(element => {
          this.totalSells += parseInt(element.numberOfSell);
        });
        // this.data.chart.forEach(element => {
        //   this.website_traffic.dates.push(element.date);
        //   this.website_traffic.visitors.push(element.count);
        // });
        // this.data.chart2.forEach(element => {
        //   this.website_traffic2.dates.push(element.date);
        //   this.website_traffic2.visitors.push(element.count);
        // });
      });
      // this.$refs.line.update();
      // this.$refs.line2.update();
      await this.$vs.loading.close();
    }
  },
  computed: {
    lables() {
      return this.website_traffic.dates;
    },

    numbers() {
      return this.website_traffic.visitors;
    },

    lables2() {
      return this.website_traffic2.dates;
    },

    numbers2() {
      return this.website_traffic2.visitors;
    }
  }
};
</script>
